import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideSquare = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <rect
      width={18}
      height={18}
      x={3}
      y={3}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      rx={2}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideSquare);
const Memo = memo(ForwardRef);
export default Memo;
